var map = {
	"./Duality/1.Grounded.mp3": 9,
	"./Duality/2.Traditionaly Untraditional.mp3": 10,
	"./Duality/3.Interlusion.mp3": 11,
	"./Duality/4.WhoAndWhereNoHow.mp3": 12,
	"./Duality/5.Crumble me (ft. Josh Biltekoff).mp3": 13,
	"./Duality/6.Grapes of Wrath (ft. Josh Biltekoff).mp3": 14
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34;